import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveLegacyPath } from '@/lib/legacyRedirects';
import RedirectTo from './RedirectTo';
import NotFoundPage from './NotFoundPage';

const SlugResolver = React.lazy(() => import('./SlugResolver'));

// Single fallback route: legacy URL → canonical redirect, one-segment slug →
// CMS record (landing page / Journal article), anything else → real 404.
export default function CatchAllRoute() {
  const { pathname } = useLocation();
  const target = resolveLegacyPath(pathname);
  if (target) return <RedirectTo to={target} />;

  const segments = pathname.split('/').filter(Boolean);
  // /en/<slug>: EN CMS record published after the last build (built ones have literal routes).
  if (segments.length === 2 && segments[0] === 'en') {
    return (
      <Suspense fallback={<div className="min-h-screen bg-[#faf5ea]" />}>
        <SlugResolver slug={decodeURIComponent(segments[1])} lang="en" />
      </Suspense>
    );
  }
  if (segments.length !== 1) return <NotFoundPage />;

  return (
    <Suspense fallback={<div className="min-h-screen bg-[#faf5ea]" />}>
      <SlugResolver slug={decodeURIComponent(segments[0])} />
    </Suspense>
  );
}